var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({attrs:{"variant":_vm.copyColor,"title":"Copy"},on:{"click":_vm.copy}},'b-button',_vm.buttonProps,false),[_c(_vm.copyIcon,{tag:"component"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }